// extracted by mini-css-extract-plugin
module.exports = {"cardSliderModule":"CardSliderModule_cardSliderModule__gri9j"};